import i18n from '@/common/i18n';
import computedLocale from '@/common/utils/computedLocale';
import { NetworkType } from '@schema';

export const MIN_VLAN_ID = 1;
export const MAX_VLAN_ID = 4094;

export const MIN_MTU = 1;
export const MAX_MTU = 65535;

export const MIN_PHYSICAL_NETWORK_MTU = 60;
export const DEFAULT_PHYSICAL_NETWORK_MTU = 1500;
export const MAX_PHYSICAL_NETWORK_MTU = 9000;

export const ACCESS_ROUTED = 'routed';
export const ACCESS_DIRECT = 'direct';
export const ACCESS_MIXED = 'mixed';

export const DEFAULT_ROUTE_CIDR = '0.0.0.0/0';

export const DEFAULT_ROUTE_CIDR_IPV6 = '::/0';

export const DENY_ALL_CIDRS = [DEFAULT_ROUTE_CIDR, DEFAULT_ROUTE_CIDR_IPV6];

export const isDenyAllList = (denyList: string[] = []): boolean => denyList.includes(DEFAULT_ROUTE_CIDR)
  && denyList.every(cidr => DENY_ALL_CIDRS.includes(cidr));

export const COMPUTE_NETWORK_TYPES = {
  EXTERNAL: 'external',
  PRIVATE: 'private'
};

export const TYPES = {
  [NetworkType.FLAT]: COMPUTE_NETWORK_TYPES.EXTERNAL,
  [NetworkType.VLAN]: COMPUTE_NETWORK_TYPES.EXTERNAL,
  [NetworkType.VXLAN]: COMPUTE_NETWORK_TYPES.PRIVATE
};

export const TYPES_MAP = {
  external: [NetworkType.FLAT, NetworkType.VLAN],
  private: [NetworkType.VXLAN]
};

export const NETWORK_TYPES = {
  PHYSICAL: 'physical',
  VIRTUAL: 'virtual'
};

export const NETWORK_PHYSICAL_TYPES = {
  VLAN: 'vlan',
  UNTAGGED: 'untagged'
};

export const SECURITY_GROUP_DEFAULT_NAME = 'default';

export const IPV6_RA_MODES = {
  NONE: '',
  SLAAC: 'slaac',
  DHCPV6_STATEFUL: 'dhcpv6-stateful',
  DHCPV6_STATELESS: 'dhcpv6-stateless'
};

export const IPV6_RA_MODES_LABELS = computedLocale(() => ({
  [IPV6_RA_MODES.NONE]: i18n.t('None'),
  [IPV6_RA_MODES.SLAAC]: i18n.t('SLAAC'),
  [IPV6_RA_MODES.DHCPV6_STATEFUL]: i18n.t('DHCPv6 stateful'),
  [IPV6_RA_MODES.DHCPV6_STATELESS]: i18n.t('DHCPv6 stateless')
}));

export const IPV6_ADDRESS_MODES = {
  NONE: '',
  SLAAC: 'slaac',
  DHCPV6_STATEFUL: 'dhcpv6-stateful',
  DHCPV6_STATELESS: 'dhcpv6-stateless'
};

export const IPV6_ADDRESS_MODES_LABELS = computedLocale(() => ({
  [IPV6_ADDRESS_MODES.NONE]: i18n.t('None'),
  [IPV6_ADDRESS_MODES.SLAAC]: i18n.t('SLAAC'),
  [IPV6_ADDRESS_MODES.DHCPV6_STATEFUL]: i18n.t('DHCPv6 stateful'),
  [IPV6_ADDRESS_MODES.DHCPV6_STATELESS]: i18n.t('DHCPv6 stateless')
}));

export const ACCESS_RULES = {
  ALLOW_ALL: 'allowAll',
  DENY_ALL: 'denyAll',
  CUSTOM: 'custom'
};
